export const replaceTextBetween = (htmlNodeAsString: string) => {
  const strippedPTag = htmlNodeAsString.replace(/^<p[^>]*>|<\/p>$/g, "");
  const strippedDivTag = strippedPTag.replace(/^<div[^>]*>|<\/div>$/g, "");

  const divConvert = "<div>" + strippedDivTag + "</div>";

  return replaceFontFamily(divConvert);
};

export const replaceFontFamily = (str: string) => {
  return str.replace(/(font-family:\s?).+?((?=;|"))/g, "$1inherit$2");
};

export default replaceTextBetween;
